import { render, staticRenderFns } from "./Infographic5.vue?vue&type=template&id=3a874cf4&scoped=true&"
import script from "./Infographic5.vue?vue&type=script&lang=js&"
export * from "./Infographic5.vue?vue&type=script&lang=js&"
import style0 from "./Infographic5.vue?vue&type=style&index=0&id=3a874cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a874cf4",
  null
  
)

export default component.exports